import { IOcaShipping, Pagination } from '../../interfaces/deliveries.interface';
import { UploadProgress } from '../../services/file-upload/file-upload.service';

export namespace OcaDeliveriesActions {
  export class GetOcaDeliveries {
    static readonly type = '[OcaDeliveries] Get OcaDeliveries';
    constructor(
      public fechaDesde?: string, 
      public fechaHasta?: string,
      public page?: number,
      public pageSize?: number,
      public estado?: string,
      public q?: string,
      public devoluciones?: boolean,
      public estadoInterno?: string,
    ) {}
  }

  export class SetOcaDeliveries {
    static readonly type = '[OcaDeliveries] Set OcaDeliveries';
    constructor(public deliveries: Pagination<IOcaShipping>) {}
  }

  export class GetOcaDeliveryById {
    static readonly type = '[OcaDeliveries] Get OcaDelivery By trackingNumber';
    constructor(public trackingNumber: string) {}
  }

  export class GetOcaReturnById {
    static readonly type = '[OcaDeliveries] Get OcaReturn By trackingNumber';
    constructor(public trackingNumber: string) {}
  }

  export class UploadOcaFile {
    static readonly type = '[OcaDeliveries] Upload Oca File';
    constructor(
      public shippingId: string, 
      public receiptId: number,
      public file: File,
      public trackingNumber: string,
      public isReturn: boolean = false
    ) {}
  }

  export class UploadOcaFiles {
    static readonly type = '[OcaDeliveries] Upload Oca Files';
    constructor(
      public shippingId: string, 
      public receiptId: number,
      public files: File[],
      public trackingNumber: string,
      public isReturn: boolean = false
    ) {}
  }

  export class UploadOcaFileProgress {
    static readonly type = '[OcaDeliveries] Upload Oca File Progress';
    constructor(public progress: UploadProgress) {}
  }

  export class UploadOcaFilesProgress {
    static readonly type = '[OcaDeliveries] Upload Oca Files Progress';
    constructor(public progress: UploadProgress) {}
  }

  export class UploadOcaFileSuccess {
    static readonly type = '[OcaDeliveries] Upload Oca File Success';
    constructor(public response: any) {}
  }

  export class UploadOcaFilesSuccess {
    static readonly type = '[OcaDeliveries] Upload Oca Files Success';
    constructor(public response: any) {}
  }

  export class UploadOcaFileError {
    static readonly type = '[OcaDeliveries] Upload Oca File Error';
    constructor(public error: string) {}
  }

  export class UploadOcaFilesError {
    static readonly type = '[OcaDeliveries] Upload Oca Files Error';
    constructor(public error: string) {}
  }
}
